if ($('#navigation-1 span[itemprop="name"]').text() === 'Návody na pestovanie rastlín') {
    $('body').addClass('navodaNaPestovani');
    function addReadMoreBtn() {
        $('.news-item').each(function () {
            var $item = $(this);
            var link = $item.find('a.title').attr('href');
            if ($item.find('.read-more').length) return;

            if (link) {
                $item.find('.description').append(
                    $('<a>', {
                        href: link,
                        text: 'Přečíst celý článek',
                        class: 'read-more'
                    })
                );
            }
        });
    }

    $(document).ready(function () {
        addReadMoreBtn();
    });

    document.addEventListener('ShoptetPagePaginationUsed', function () {
        document.addEventListener('ShoptetDOMPageContentLoaded', function handler() {
            addReadMoreBtn();
            document.removeEventListener('ShoptetDOMPageContentLoaded', handler);
        });
    });

}